module.exports = __webpack_public_path__ + "static/media/FFE2354_BY.2f973588.jpg";